import { useSyncExternalStore } from 'react';

const STORAGE_KEY = 'melodiza:local-zones';

function load() {
  try {
    const raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(raw) ? raw : [];
  } catch {
    return [];
  }
}

let _zones = load();
const _listeners = new Set();

function emit() {
  _listeners.forEach((l) => l());
}

function persist() {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(_zones));
  } catch (err) {
    console.error('[localZones] persist failed:', err);
  }
}

function subscribe(listener) {
  _listeners.add(listener);
  return () => _listeners.delete(listener);
}

function getSnapshot() {
  return _zones;
}

if (typeof window !== 'undefined') {
  window.addEventListener('storage', (e) => {
    if (e.key !== STORAGE_KEY) return;
    _zones = load();
    emit();
  });
}

function uuid() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID)
    return crypto.randomUUID();
  return `local-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export function createLocalZone({ name, deviceType = 'web' }) {
  const zone = {
    id: uuid(),
    name,
    deviceType,
    deviceId: null,
    volume: 0.7,
    isPlaying: false,
    currentTrackId: null,
    isLocal: true,
    createdAt: new Date().toISOString(),
  };
  _zones = [..._zones, zone];
  persist();
  emit();
  return zone;
}

export function updateLocalZone(id, patch) {
  _zones = _zones.map((z) => (z.id === id ? { ...z, ...patch } : z));
  persist();
  emit();
}

export function deleteLocalZone(id) {
  _zones = _zones.filter((z) => z.id !== id);
  persist();
  emit();
}

export function isLocalZoneId(id) {
  return _zones.some((z) => z.id === id);
}

export function useLocalZones() {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
